var MpPageService;

(function() {
    if (!document.querySelector('#vue-service') || ['contact', 'request'].indexOf(GLOBAL_SECTION) >= 0) {
        return;
    }

    var mixin;

    // Legacy funcionality management in a single class because same idBody
    // fom ServicesController. Here we manage it through mixins.
    var serviceList = {
        oiltimemarket: MpOtmService,
    };

    if (serviceList[GLOBAL_SECTION]) {
        mixin = serviceList[GLOBAL_SECTION];
    } else {
        mixin = '';
    }

    MpPageService = new Vue({
        el: '#vue-service',
        mixins: [mixin, MpScrollTo],
        data: {
            serviceCarousel: null,
            galleryCarousel: null,
        },
        computed: {},
        methods: {

            showSlide: function(ev) {
                if (!ev.target.matches('.js-pagination-link')) return;

                ev.preventDefault();
                this.serviceCarousel.slideTo(ev.target.getAttribute('data-index'));
            },

            onSlideChange: function() {
                var swiperChipActive,
                    swiperChips;

                swiperChipActive = document.getElementsByClassName('service-carousel__pagination-link--active');
                swiperChipActive[0].classList.remove('service-carousel__pagination-link--active');

                swiperChips = document.getElementsByClassName('js-pagination-link');
                swiperChips[this.serviceCarousel.realIndex].classList.add('service-carousel__pagination-link--active');
            },

            initSwiper: function() {
                if (!document.querySelector('.js-service-carousel')) {
                    return;
                }

                this.serviceCarousel = new Swiper('.js-service-carousel', {
                    effect: 'fade',
                    // slidesPerView: 'auto',
                    // spaceBetween: 10,
                    // Navigation arrows
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    pagination: {
                        el: '.swiper-pagination',
                        dynamicBullets: true,
                        clickable: true
                    },
                    on: {
                        init: function() {
                            var swiperChips = document.getElementsByClassName('js-pagination-link');
                            swiperChips[this.realIndex].classList.add('service-carousel__pagination-link--active');
                        },
                    },
                });

                this.serviceCarousel.on('slideChange', this.onSlideChange);
            },

            initGallery: function() {
                if (!this.$refs.gallerySlider) {
                    return;
                }

                this.galleryCarousel = new Swiper(this.$refs.gallerySlider, {
                    slidesPerView: 'auto',
                    freeMode: true,
                });
            },

            init: function() {
                if (this.isInitialized) {
                    return;
                }

                this.isInitialized = true;
                this.initSwiper();
                this.initGallery();
            },
        },
        filters: {},

        mounted: function() {
            this.init();
        },

        updated: function() {
            if (!this.isInitialized) {
                this.init();
            }
        },

        destroy: function() {},
    });

})();
